import "./App.css";

import ProductCalculator from "./components/ProductCalculator";
function App() {
	return (
		<div id="root">
			<div id="mvis-calc">
				<div className="App">
					{/* <div className="content">
						<div className="Row">
							<div className="col-lg-5 mx-auto text-justify">
								<p className="intro-text">
									Use the calculator below to determine your potential savings
									when using our Masonry Veneer Installation System (MVIS)
								</p>
							</div>
						</div>
					</div> */}

					<ProductCalculator />
				</div>
			</div>
		</div>
	);
}

export default App;
